import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

type systemSettingDataType = {
  block_name: string;
  errorCallback?: Function;
  successCallback?: Function;
  resultKey?: string;
};

export default ({
  block_name,
  errorCallback,
  successCallback,
  resultKey = 'systemSettingsData',
}: systemSettingDataType) =>
  requestAsync({
    url: endpoints.getSystemSettingsUrl(block_name),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getSystemSettingsUrl(block_name),
    options: {
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      authToken: true,
      errorCallback,
      successCallback,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
